import Tools from './../components/tools';

export default class Contact {
    constructor() {
        this.showSubmit();
        this.showMedecin();
        this.showActivite();

        const groups = ['c_besoin[]', 'c_ordonnance', 'c_deja_venu', 'c_covid', 'c_connu'];
        groups.forEach( group => {
            this.manageRequiredFields(document.querySelectorAll(`input[name="${group}"]`));
        });

        this.tools = new Tools();
    }

    manageRequiredFields(group) {
        let isFirstCheck = true;

        group.forEach( elt => {
            elt.addEventListener('click', () => {
                if (isFirstCheck) {
                    group.forEach( e => {
                        if (e != elt) {
                            e.required = false;
                        } else {
                            e.required = true;
                        }
                    });
                } else {
                    elt.required = !elt.required;
                }
            });
        });
    }

    showSubmit() {
        const btnSubmit = document.querySelector('.page-template-contact section article form button[type=submit]');
        if (btnSubmit) {
            window.onscroll = () => {
                if (window.pageYOffset > this.tools.offset( document.querySelector('footer') ).top - window.innerHeight) {
                    btnSubmit.querySelector('svg').style.strokeDashoffset = '0';
                }
            }
        }
    }

    showMedecin() {
        const btnsMedecin = document.querySelectorAll('.page-template-contact section article form .wrapper fieldset input[name="c_connu"]'),
              fieldsetMedecin = document.querySelector('.page-template-contact section article form .wrapper fieldset.is-medecin');

        if (btnsMedecin.length > 0) {
            btnsMedecin.forEach( btnMedecin => {
                btnMedecin.addEventListener('change', () => {
                    if (btnMedecin.value == 'Medecin') {
                        fieldsetMedecin.style.display = 'block';
                        fieldsetMedecin.querySelector('input').required = true;
                    } else {
                        fieldsetMedecin.style.display = 'none';
                        fieldsetMedecin.querySelector('input').required = false;
                    }
                });
            });
        }
    }

    showActivite() {
        const btnsActivite = document.querySelectorAll('.page-template-contact section article form .wrapper fieldset input[name="c_activite"]'),
              fieldsetActivite = document.querySelector('.page-template-contact section article form .wrapper fieldset.is-activite');

        if (btnsActivite.length > 0) {
            btnsActivite.forEach( btnActivite => {
                btnActivite.addEventListener('change', () => {
                    if (btnActivite.value == 'Oui') {
                        fieldsetActivite.style.display = 'block';
                        fieldsetActivite.querySelector('input').required = true;
                    } else {
                        fieldsetActivite.style.display = 'none';
                        fieldsetActivite.querySelector('input').required = false;
                    }
                });
            });
        }
    }
}